/* eslint consistent-return: off */

import { useEffect, useRef } from 'react'

export default function useEventListener(
  eventName,
  handler,
  count,
  setCount,
  element = window
) {
  // Create a ref that stores handler
  const savedHandler = useRef()

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler
  }, [handler])

  useEffect(
    () => {
      // Make sure element supports addEventListener
      const isSupported = element && element.addEventListener
      if (!isSupported) return

      // Create event listener that calls handler function stored in ref
      const eventListener = (event) => {
        if (count === 0) {
          savedHandler.current(event)
          return 0
        }
      }

      // Add event listener
      element.addEventListener(eventName, eventListener)

      // Remove event listener on cleanup

      return () => {
        element.removeEventListener(eventName, eventListener)
        setTimeout(() => {
          setCount(0)
        }, 4000)
      }
    },
    [eventName, element, count] // Re-run if eventName or element changes
  )
}
